import { formatDate } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItemSettingBookingWindow } from '../editor-booking-item-setting/editor-booking-item-setting-booking-window.model';


@Component({
    selector: 'eas-editor-booking-item-setting-value-booking-window',
    templateUrl: './editor-booking-item-setting-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingValueBookingWindowComponent implements OnChanges, OnInit {
  @Input() itemSetting: EditorBookingItemSettingBookingWindow;

  value: string;

  constructor(@Inject(LOCALE_ID) private locale: string) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  getValue(): string {
    const formattedOpen = this.itemSetting.open === null ? null : formatDate(this.itemSetting.open.toDate(), 'short', this.locale);
    const formattedDateOpen = this.itemSetting.open === null ? null : formatDate(this.itemSetting.open.toDate(), 'shortDate', this.locale);
    const formattedTimeOpen = this.itemSetting.open === null ? null : formatDate(this.itemSetting.open.toDate(), 'shortTime', this.locale);
    const formattedClose = this.itemSetting.close === null ? null : formatDate(this.itemSetting.close.toDate(), 'short', this.locale);
    const formattedDateClose = this.itemSetting.close === null ? null : formatDate(this.itemSetting.close.toDate(), 'shortDate', this.locale);
    const formattedTimeClose = this.itemSetting.close === null ? null : formatDate(this.itemSetting.close.toDate(), 'shortTime', this.locale);

    let summary: string;
    if (this.itemSetting.open !== null && this.itemSetting.close !== null) {
      summary = (formattedDateOpen === formattedDateClose)
        ? $localize `${formattedDateOpen}, ${formattedTimeOpen} to ${formattedTimeClose}`
        : $localize `${formattedOpen} to ${formattedClose}`;
    } else if (this.itemSetting.open !== null) {
      summary = $localize `${formattedOpen} to ...`;
    } else if (this.itemSetting.close) {
      summary = $localize `... to ${formattedClose}`;
    }

    if (summary === undefined) {
      return '';
    }

    if (this.itemSetting.timezone !== null) {
      summary = `${summary} ${this.itemSetting.timezone}`;
    }

    return summary;
  }
}
